module.exports = __webpack_public_path__ + "static/seres-silk-duvet-1-4d508bc642780337acc4c9eb3fc456de.mp4";